import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SmartViewsService {


  constructor(
    private http: HttpClient
  ) { }

  url = environment.serverAPI9 + "/api/smartViews";

  searchSmartViews(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getSmartViews(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  CreateSmartViews(units: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, units)
  }

  getSmartViewsById(smartViewId: number): Observable<Object> {
    return this.http.get(`${this.url}/${smartViewId}`);
  }
  getSmartViewsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/list`);
  }

  getSmartViewsDropDownType(type): Observable<Object> {
    return this.http.get(`${this.url}/list/type/${type}`);
  }

  deleteBySmartViewsId(smartViewId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${smartViewId}`);
  }
}
